<template><div>
    <div class="price-select">
        <slot><div class="price-select__title">MyPrice</div></slot>

        <div class="price-select__blocks">
            <label class="price-select__label">
                <input
                    v-model="pmin"
                    class="price-select__input"
                    type="text"
                    :class="{red: error_min()}"
                    :placeholder="props.list[0]"
                >

                <span class="price-select__text">
                    от
                </span>
            </label>
            <label class="price-select__label">
                <input
                    v-model="pmax"
                    class="price-select__input"
                    type="text"
                    :class="{red: error_max()}"
                    :placeholder="props.list[1]"
                >

                <span class="price-select__text">
                    до
                </span>
            </label>
        </div>
    </div>

</div></template>

<style lang="scss" src="./MyPrice.scss"></style>

<script setup>
import {ref, computed, reactive, unref, watch} from 'vue'
import {debounce} from '@/util.js'

const props = defineProps({
  list: Array,  // 0 - от 1 - до
  choosedFrom: String,
  choosedTo: String,
})
const emits = defineEmits([ 'input' ])

const tmp = ref({from: '', to: ''})


const clean = v => v.replace(/[ +]/g, '')

const error_min = () => {
    let v = unref(tmp).from
    let ret = false
    if (v) {
        let t = parseFloat(v, 10)
        ret = isNaN(t) || t<0
    }
    return ret
}
const error_max = () => {
    let v = unref(tmp).to
    let toerr = false
    if (v) {
        let t = parseFloat(v, 10)
        toerr = isNaN(t) || t <= 0
        if (!toerr) {
            let vv = unref(tmp).from
            toerr = vv && parseFloat(vv, 10) > t
        }
    }
    return toerr
}

const emi = ()=>{
    if (error_min() || error_max()) {
    }else{
        let { from, to} = unref(tmp)
        emits('input', {from, to})
    }
}

const debounce_emit = debounce( emi, 200)

const pmin = computed({
    get() {
        return unref(tmp).from
    }, 
    set(setFrom) {
        tmp.value.from = clean(setFrom)
        debounce_emit()
    }
})
const pmax = computed({
    get() {
        return unref(tmp).to
    }, 
    set(setTo) {
        tmp.value.to = clean(setTo)
        debounce_emit()
    }
})



const set_tmp = () => {
    let {choosedFrom, choosedTo} = props
    tmp.value = {
        from: choosedFrom,
        to: choosedTo,
    }
}

watch( 
    [ 
        () => props.choosedFrom,
        () => props.choosedTo,
    ],

    set_tmp,

    { immediate: true }
)


</script>
